<script >
import { ref, defineAsyncComponent, onBeforeMount } from 'vue-demi';
const BusinessDataChart = defineAsyncComponent(() => import('@futuweb/quote-charts/lib/BusinessData'));
const __sfc_main = {};
__sfc_main.props = {
  stockId: Number || String,
  lang: Number,
  theme: Number
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useCommonApi,
    useEnv
  } = require('@fegobull/webapi').use;
  const {
    get
  } = useCommonApi('business-data-chart');
  const {
    isPreRender
  } = useEnv();
  const props = __props;
  const dataSource = ref(null);
  !isPreRender && onBeforeMount(async () => {
    try {
      const rsp = await get('get-stock-businessdata-list', {
        stock_id: props.stockId,
        lang: props.lang
      });
      dataSource.value = rsp;
    } catch (e) {
      console.error(e);
      dataSource.value = null;
    }
  });
  return {
    dataSource
  };
};
__sfc_main.components = Object.assign({
  BusinessDataChart
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div
        :class="[
            'business-data-chart',
            {
                pc: isPc
            }
        ]"
    >
        <BusinessDataChart v-if="dataSource" :dataSource="dataSource" :theme="theme" :lang="lang" />
    </div>
</template>
<style lang="css" scoped>
@import '@futuweb/quote-charts/lib/BusinessData/style/index.css';
</style>
